import { render, staticRenderFns } from "./transactions.vue?vue&type=template&id=fd545846"
import script from "@/scripts/gpuHub/transactions/transactions.js?vue&type=script&lang=js&external"
export * from "@/scripts/gpuHub/transactions/transactions.js?vue&type=script&lang=js&external"
import style0 from "./transactions.vue?vue&type=style&index=0&id=fd545846&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports